import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import ArrowBack from '@nerdwallet/react-icon/nerdwallet-ui/Back';
import Close from '@nerdwallet/react-icon/nerdwallet-ui/Close';
import { Box } from '../Box/Box';
import { SecureEncryptionMessage } from '../SecureEncryptionMessage/SecureEncryptionMessage';
import { Text } from '../Text/Text';
import styles from './ModalContent.module.less';
export var ModalContent = function ModalContent(_ref) {
  var children = _ref.children,
      onRequestBack = _ref.onRequestBack,
      onRequestClose = _ref.onRequestClose,
      shouldShowSecurityMessage = _ref.shouldShowSecurityMessage,
      shouldShowBack = _ref.shouldShowBack,
      subtitle = _ref.subtitle,
      title = _ref.title,
      titleElementId = _ref.titleElementId;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.content)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.navContainer
  }, shouldShowBack &&
  /*#__PURE__*/
  // eslint-disable-next-line react/button-has-type -- directive added automatically by Shepherd migration
  React.createElement("button", {
    "aria-label": "Previous dialog",
    className: classNames(styles.button, styles.backButton),
    onClick: onRequestBack
  }, /*#__PURE__*/React.createElement(ArrowBack, {
    size: 24
  })), /*#__PURE__*/React.createElement("button", {
    "aria-label": "Close dialog",
    className: classNames(styles.button, styles.closeButton),
    onClick: onRequestClose
  }, /*#__PURE__*/React.createElement(Close, {
    size: 24
  }))), title && /*#__PURE__*/React.createElement("div", {
    className: classes('margin-bottom-3')
  }, /*#__PURE__*/React.createElement(Box, {
    marginTop: 2
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    component: "h1",
    id: titleElementId,
    size: "large"
  }, title)), subtitle && /*#__PURE__*/React.createElement(Box, {
    marginTop: 2,
    marginBottom: 4
  }, /*#__PURE__*/React.createElement(Text, {
    component: "h2" // Since we need to use neutral-darkest
    // for an accessible contrast ratio, we make the
    // subtitle text of the modal
    // smaller to differentiate the two.
    ,
    size: "small"
  }, subtitle))), children, shouldShowSecurityMessage && /*#__PURE__*/React.createElement("div", {
    className: classes('margin-top-3')
  }, /*#__PURE__*/React.createElement(SecureEncryptionMessage, null)));
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  ModalContent.propTypes = {
    children: PropTypes.node,

    /**
     * Run after the modal's back button is clicked.
     */
    onRequestBack: PropTypes.func,

    /**
     * Run when the modal is requested to be closed (either by clicking on overlay or pressing ESC)
     * Note: It is not called if isOpen is changed by other means.
     */
    onRequestClose: PropTypes.func,

    /**
     * Flag to indicate if 128-bit encryption block should be shown.
     */
    shouldShowSecurityMessage: PropTypes.bool,

    /**
     * Indicates if the back button should be shown.
     */
    shouldShowBack: PropTypes.bool,

    /**
     * The subtitle text of the modal
     */
    subtitle: PropTypes.string,

    /**
     * The title text of the modal
     */
    title: PropTypes.string,

    /**
     * [Optional] id for the title's dom element. If not provided, an autogenerated id will be used
     */
    titleElementId: PropTypes.string
  };
}

ModalContent.defaultProps = {
  children: null,
  onRequestBack: function onRequestBack(f) {
    return f;
  },
  onRequestClose: function onRequestClose(f) {
    return f;
  },
  shouldShowBack: false,
  shouldShowSecurityMessage: false,
  subtitle: null,
  title: null,
  titleElementId: undefined
};